module.exports = __webpack_public_path__ + "img/p4.db27e4a0.png";